import surveysActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../util/createReducer';

const SURVEY_DETAIL_INITIAL_STATE = {
  surveyDetail: {},
};

const USER_SURVEYS_INITIAL_STATE = {
  surveyResponses: [],
  initializing: false,
  surveys: [],
};

export const reducers = {
  createSurvey: createAsyncRequestReducer(
    surveysActionTypes.SURVEYS_CREATE_SURVEY,
  ),
  updateSurvey: createAsyncRequestReducer(
    surveysActionTypes.SURVEYS_UPDATE_SURVEY,
  ),
  fetchProjectSurveyResponses: createAsyncRequestReducer(
    surveysActionTypes.SURVEYS_FETCH_SURVEY_RESPONSE,
  ),
  fetchSurveyResponsePatients: createAsyncRequestReducer(
    surveysActionTypes.SURVEYS_FETCH_SURVEY_RESPONSE_PATIENTS,
  ),
  sendSurvey: createAsyncRequestReducer(surveysActionTypes.SURVEYS_SEND_SURVEY),
  sendSurveyToNewSubject: createAsyncRequestReducer(
    surveysActionTypes.SEND_SURVEY_INVITE_TO_NEW_SUBJECT,
  ),
  surveyDetail: createReducer(SURVEY_DETAIL_INITIAL_STATE, {
    [surveysActionTypes.SURVEYS_CLEAR_SURVEY_DETAIL]: () => {
      return {};
    },
    [surveysActionTypes.SURVEYS_SET_SURVEY_DETAIL_SURVEY]: (
      state: any,
      action: any,
    ) => {
      return {
        ...state,
        survey: action.survey,
      };
    },
    [surveysActionTypes.SURVEYS_SET_SURVEY_DETAIL_PATIENTS]: (
      state: any,
      action: any,
    ) => {
      return {
        ...state,
        patients: action.patients || [],
      };
    },
    [surveysActionTypes.SURVEYS_INITIALIZATION_START]: (state: any) => {
      return {
        ...state,
        initialized: false,
      };
    },
    [surveysActionTypes.SURVEYS_SET_SURVEY_RESPONSES]: (
      state: any,
      action: any,
    ) => {
      return {
        ...state,
        surveyResponses: action.surveyResponses || [],
      };
    },
    [surveysActionTypes.SURVEYS_INITIALIZATION_END]: (state: any) => {
      return {
        ...state,
        initialized: true,
      };
    },
    [surveysActionTypes.SURVEYS_APPEND_NEW_RESPONSE_TO_DETAILS]: (
      state: any,
      action: any,
    ) => {
      return {
        ...state,
        responses: [...(state.responses || []), action.response],
        patients: [...(state.patients || []), action.patient],
      };
    },
  }),
  userSurveys: createReducer(USER_SURVEYS_INITIAL_STATE, {
    [surveysActionTypes.SURVEYS_RESET_USER_SURVEY_STATE]: () => {
      return USER_SURVEYS_INITIAL_STATE;
    },
    [surveysActionTypes.SURVEYS_SET_USER_SURVEY_INITIALIZING]: (
      state: any,
      action: any,
    ) => {
      return {
        ...state,
        initializing: action.initializing,
      };
    },
    [surveysActionTypes.SURVEYS_SET_USER_RESPONSES]: (
      state: any,
      action: any,
    ) => {
      return {
        ...state,
        surveyResponses: action.surveyResponses,
      };
    },
    [surveysActionTypes.SURVEYS_ADD_USER_SURVEYS]: (
      state: any,
      action: any,
    ) => {
      return {
        ...state,
        surveys: action.surveys,
      };
    },
  }),
};

export default combineReducers(reducers);
